import { featuredCategories } from '@/mocks/categories';

export default function ValueSection() {
  const cardImages = [
    "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20elegant%20sneakers%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20style%2C%20neutral%20warm%20beige%20tones%2C%20clean%20aesthetic%2C%20no%20text&width=600&height=400&seq=val-shoes-001&orientation=landscape",
    "https://readdy.ai/api/search-image?query=Minimalist%20photography%20of%20a%20folded%20cozy%20hoodie%20sweater%20on%20warm%20cream%20surface%2C%20soft%20lighting%2C%20editorial%20style%2C%20neutral%20warm%20tones%2C%20clean%20aesthetic%2C%20no%20text&width=600&height=400&seq=val-hoodies-002&orientation=landscape",
    "https://readdy.ai/api/search-image?query=Clean%20minimalist%20photography%20of%20folded%20cotton%20t-shirts%20on%20warm%20cream%20surface%2C%20soft%20natural%20light%2C%20editorial%20style%2C%20neutral%20beige%20tones%2C%20no%20text&width=600&height=400&seq=val-tshirts-003&orientation=landscape",
    "https://readdy.ai/api/search-image?query=Minimalist%20photography%20of%20a%20stylish%20light%20jacket%20on%20warm%20cream%20surface%2C%20soft%20shadows%2C%20editorial%20style%2C%20neutral%20warm%20beige%20tones%2C%20clean%20aesthetic%2C%20no%20text&width=600&height=400&seq=val-jackets-004&orientation=landscape",
    "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20photography%20of%20folded%20casual%20pants%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20style%2C%20neutral%20warm%20tones%2C%20clean%20aesthetic%2C%20no%20text&width=600&height=400&seq=val-pants-005&orientation=landscape",
  ];

  return (
    <section id="value" className="bg-foreground-950 py-20 md:py-28">
      <div className="w-full px-6 md:px-10 max-w-6xl mx-auto text-center">
        <p className="text-foreground-400 text-xs md:text-sm uppercase tracking-widest mb-4 font-medium">
          Trusted by 10,000+ Resellers
        </p>
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-10 max-w-3xl mx-auto">
          AllChinaBuySpreadsheet<br />
          Combines Product Discovery<br />
          And Supplier Comparison
        </h2>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-white text-foreground-950 rounded-lg text-sm font-semibold hover:bg-white/90 transition-all duration-300 cursor-pointer whitespace-nowrap w-full sm:w-auto"
          >
            allchinabuy sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 border border-white/30 text-white rounded-lg text-sm font-semibold hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap w-full sm:w-auto"
          >
            buy it now
          </a>
        </div>

        {/* Category Cards with Images */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
          {featuredCategories.slice(0, 5).map((cat, i) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-xl overflow-hidden cursor-pointer min-h-[180px]"
            >
              <img
                src={cardImages[i]}
                alt={cat.name}
                className="w-full h-full object-cover object-top absolute inset-0 group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-7 h-7 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-white text-xs"></i>
                  </div>
                </div>
                <span className="text-white text-sm font-semibold whitespace-nowrap">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}